export const de = {
  navigation: {
    title: "Übungen",
    games: {
      catchtheball: "Fang den Ball",
      remember: "Symbole merken",
      fingerlauf: "Fingerlauf",
      numberjungle: "Zahlen-Dschungel",
      onposition: "Auf Position",
      bleistiftakrobatik: "Bleistiftakrobatik",
      crossword: "Rasterlauf",
      scramble: "Buchstabensalat",
      fingerskilled: "Fingerfertig",
      armsup: "Hoch die Arme",
    },
  },
  home: {
    title: "Mental fit? Machen Sie den Fitnessparcours fürs Gehirn.",
    subtitle: "Wie fit sind eigentlich Ihre grauen Zellen?",
    intro:
      "So wie Sie durch regelmäßiges Training Ihren Körper fit halten können, können Sie auch etwas für Ihre geistige Vitalität tun. In unserem Fitness-Parcours lernen Sie Möglichkeiten für gezieltes geistiges Training kennen. Dabei geht es vor allem um den Kurzspeicher. Im Gegensatz zum Langzeitgedächtnis ist er sehr störanfällig, weshalb es gut ist, wenn er regelmäßig gefordert wird: Täglich 10 Minuten reichen.",
    closure_first:
      "Mehr zum Thema erfahren Sie auch im Artikel",
    closure_fat: "»Training fürs Gehirn«",
    closure_last: " in unseren Info-Kanälen."
  },

  games: {
    back: "Zurück zur Auswahl",
    start: "Start",
    training: "Randbemerkung",
  },
};
